import { useState, useCallback } from 'react';

const useChangeModalVisible = () => {
  const [visible, setVisible] = useState(false);

  const showModal = useCallback(() => setVisible(true), []);

  const hideModal = useCallback(() => setVisible(false), []);

  return { visible, showModal, hideModal };
};

export default useChangeModalVisible;
